export default {
  props: ['modelValue'],

  data() {
    return {
      // Initialize from modelValue when provided. Otherwise keep null so
      // native input placeholder is shown instead of a pre-filled 0.
      localValue:
        this.modelValue !== undefined && this.modelValue !== null ? this.modelValue : null,
    };
  },

  ionViewWillEnter() {
    this.localValue = 0;
  },

  watch: {
    localValue(newValue) {
      this.$emit('update:modelValue', newValue);
    },
    modelValue(newValue) {
      this.localValue = newValue;
    },
  },
};
